export default {
  absence: {
    absence: "Ausente",
    absence_not_justified: "Ausencia no justificada",
    absence_waiting_for_validation: "Pendiente de validación",
    absences_not_justified: "Ausencias no justificadas",
    absences: "Ausencias",
    course: "Curso",
    company: "Empresa",
    add_notification: "Enviar una notificación de nueva certificación",
    add_event: "Añadir un evento",
    edit_event: "Modificar un evento",
    delete_event: "Eliminar un evento",
    delete_events: "Eliminar eventos",
    delete_event_sub_title: "¿Confirma que quiere eliminar este evento?",
    delete_events_sub_title: "¿Confirma que quiere eliminar estos eventos?",
    delete_event_success: "Evento eliminado correctamente",
    copy_event_success: "Evento copiado correctamente",
    cut_event_success: "Evento cortado correctamente",
    delete_events_success: "Eventos eliminados correctamente",
    post_event: "Evento añadido correctamente",
    list_planning: "Lista de eventos",
    list_planning_search: "Buscar eventos",
    import_planning: "Importar el horario",
    import_planning_success: "Planificación importada correctamente",
    export_planning: "Exportar el horario",
    export_planning_success: "Planificación exportada correctamente",
    add_absence: "Añadir una ausencia",
    edit_absence: "Modificar una ausencia",
    delete_absence: "Eliminar una ausencia",
    delete_absences: "Eliminar ausencias",
    delete_absence_sub_title: "¿Confirma que quiere eliminar esta ausencia?",
    delete_absences_sub_title: "¿Confirma que quiere eliminar estas ausencias?",
    delete_absence_success: "Ausencia eliminada correctamente",
    copy_absence_success: "Ausencia copiada correctamente",
    cut_absence_success: "Ausencia cortada correctamente",
    delete_absences_success: "Ausencias eliminadas correctamente",
    post_absence: "Ausencia añadida correctamente",
    list_absences: "Lista de ausencias",
    list_absences_search: "Buscar ausencias",
    list_attendance_certificate: "Listar los certificados de asistencia",
    attendance_certificate_export_confirmed: "Certificado de asistencia exportado con éxito !",
    list_of_attendance_certificate: "Lista de certificados de asistencia",
    no_attendance_certificate_available: "Aún no hay ningún certificado de asistencia",
    no_attendance_certificate_available_for_month: "No hay certificado de asistencia disponible para este mes",
    download_certificate: "Descargar el certificado",
    import_absences: "Importar ausencias",
    import_absences_success: "Ausencias importadas correctamente",
    notification: "Notificación de certificación",
    absence_ask: "Solicitud de autorización de ausencia excepcional",
    display_apprentice_list: "Mostrar la lista de",
    hide_apprentice_list: "Ocultar la lista de alumnos",
    training_detail: "Ver los detalles de la formación",
    apprentice_list: "Lista de",
    personnal_data: "Datos personales",
    sheet_from: "Ficha de",
    event_moved_success: "Evento desplazado correctamente",
    absence_moved_success: "Ausencia desplazada correctamente",
    justify: "Justificar",
    justify_many_absence: "Justificar varias de mis ausencias",
    submit_proof: "Presentar un justificante de ausencia",
    proof_downloaded: "Archivo descargado correctamente",
    planning: "Evento",
    not_justify: "No justificada",
    justified: "Justificada",
    in_progress: "Pendiente de validación",
    start_date: "Fecha de inicio",
    end_date: "Fecha final",
    start_time: "Hora de inicio",
    end_time: "Hora de finalización",
    duration: "Duration",
    type: "Tipo",
    verify_date: "Introduzca las fechas correspondientes al justificante presentado.",
    linked_to_planning: "Esta ausencia está relacionada con un evento",
    already_exit: "a hay una ausencia registrada para este período",
    context_menu: {
      copy: "Copiar",
      cut: "Cortar",
      paste: "Pegar",
      delete: "Eliminar",
      modify: "Modificar este evento",
      add: "Añadir un evento",
      modify_absence: "Modificar esta ausencia",
      add_absence: "Añadir una ausencia",
    },
    actions: {
      planning: "Gestión del horario",
      absences: "Gestión de la asistencia",
      options: "Opciones",
    },
    justification: {
      valid: {
        confirmation: "¿Estás seguro de que quieres validar esta ausencia?",
        success: "Ausencia validada con éxito",
      },
      unvalid: "Recibo no válido",
      status: {
        waiting_for_validation: "Pendiente de validación",
        to_verify: "Por comprobar",
        justify: "Justificar mi ausencia",
        justified: "Justificada",
        download: "Descargar el justificante de ausencia",
        waiting_proof: "A la espera de los documentos justificativos",
        invalid: "Justificación no válida",
      },
      notify_apprentice: "Notificar al estudiante en prácticas en caso de rechazo",
    },
    verification: "Control de ausencias",
    signature: {
      valid: "Confirme",
      unlock: "Desbloquear",
      invalid: "Desactivar",
      title: "Emargamiento",
      former: "Profesor",
      lesson: "Curso",
      establishment: "Establecimiento",
      component: "Componente",
      address: "Dirección",
      confirmation: "¿Está seguro de que desea validar esta firma?",
      already_validate: "Inscripción validada",
      reset: {
        title: "Restablecer ausencias y asistencias",
      },
      unlock_signature: {
        confirmation: "¿Está seguro de que desea desbloquear esta firma?",
        success: "¡Firma desbloqueada con éxito!",
      },
      valid_all_signature: "Validar todas las firmas seleccionadas",
      valid_all: {
        title: "Validación de firmas",
        confirmation: "¿Está seguro de que desea validar todas estas firmas?",
        success: "¡Firmas validadas con éxito!",
      },
      reset_absence: {
        confirmation: "Are you sure you want to reset all absences for this event?",
        subtitle: "Todos los aprendices serán trasladados a la columna 'Por definir'",
        success: "Absences successfully reset!",
      },
      signed_at: "Firmado el:",
    },
    status: {
      title: "Estado",
      absents: "Ausentes",
      to_be_defined: "Por definir",
      attendees: "Presentes",
      cancel: "Sesión cancelada",
      all_present: "Todos los presentes en la sesión",
      to_valid: "Registro por validar",
      no_absence_or_presence: " (ninguna ausencia o presencia)",
      with_absence: "Sesión validada con ausencias",
    },
    attendance_management: {
      title: "Gestión de la asistencia",
      external_title: "Gestión de asistencia con hoja de firmas",
      transfer_to: {
        absence: "Transferir todos los aprendices a la columna de ausentes",
        attendance: "Transferir todos los aprendices a la columna de presentes",
      },
    },
    presence: {
      title: ({ plural }) => plural(["Presencia", "Presencias"]),
    },
    reason: "Motivo de la ausencia",
    config: {
      valid: {
        confirmation: "¿Está seguro de que desea validar esta configuración?\n",
        success: "¡Configuración validada con éxito!",
      },
    },
    empty_unjustify: "Ninguna ausencia no justificada",
  },
};
